import { useState, useEffect, useCallback } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import { grafanaQueryApiRef } from '../api/GrafanaQueryApi';
import { useRefreshInterval } from './useRefreshInterval';
import type { GrafanaAlert } from '../api/types';

export function useGrafanaAlerts() {
  const { entity } = useEntity();
  const api = useApi(grafanaQueryApiRef);
  const [alerts, setAlerts] = useState<GrafanaAlert[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const labelSelector =
    entity.metadata.annotations?.['grafana/alert-label-selector'] ?? '';
  const { interval: refreshInterval } = useRefreshInterval();

  const refresh = useCallback(() => {
    if (!labelSelector) {
      setLoading(false);
      return;
    }
    setLoading(true);
    api
      .queryAlerts(labelSelector)
      .then(setAlerts)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [api, labelSelector]);

  useEffect(() => {
    refresh();
    const id = refreshInterval > 0 ? setInterval(refresh, refreshInterval) : undefined;
    return () => { if (id) clearInterval(id); };
  }, [refresh, refreshInterval]);

  return { alerts, loading, error, refresh };
}
